/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The slash sets a step, or interval. In the minute field, */5 means every fifth minute — 0, 5, 10, and so on — while 9-17/2 means every second hour between 9 and 17. It is a shorthand for repeating at a fixed interval instead of listing every value by hand.`)
};

const es_cr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La barra diagonal establece un paso, o intervalo. En el campo de minutos, */5 significa cada quinto minuto — 0, 5, 10, y así sucesivamente — mientras que 9-17/2 significa cada segunda hora entre 9 y 17. Es una abreviatura para repetir a un intervalo fijo en lugar de enumerar cada valor a mano.`)
};

const de_cr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Schrägstrich legt einen Schritt bzw. ein Intervall fest. Im Minutenfeld bedeutet */5 jede fünfte Minute — 0, 5, 10 und so weiter —, während 9-17/2 jede zweite Stunde zwischen 9 und 17 bedeutet. Es ist eine Abkürzung, um sich in einem festen Intervall zu wiederholen, anstatt jeden Wert einzeln aufzulisten.`)
};

const nl_cr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De schuine streep stelt een stap of interval in. In het minuutveld betekent */5 elke vijfde minuut — 0, 5, 10, enzovoort — terwijl 9-17/2 elke tweede uur tussen 9 en 17 betekent. Het is een afkorting voor herhaling met vaste intervallen in plaats van elke waarde met de hand op te sommen.`)
};

const fr_cr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La barre oblique définit une étape, ou un intervalle. Dans le champ minute, */5 signifie chaque cinquième minute — 0, 5, 10, et ainsi de suite — tandis que 9-17/2 signifie chaque deuxième heure entre 9 et 17. C'est un raccourci pour répéter à un intervalle fixe au lieu de lister chaque valeur à la main.`)
};

const it_cr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La barra imposta un incremento o intervallo. Nel campo dei minuti, */5 significa ogni quinto minuto — 0, 5, 10 e così via — mentre 9-17/2 significa ogni seconda ora tra 9 e 17. È un'abbreviazione per ripetere a intervalli fissi invece di elencare ogni valore a mano.`)
};

const pt_br2_cr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A barra define um passo ou intervalo. No campo de minutos, */5 significa cada quinto minuto — 0, 5, 10, e assim por diante — enquanto 9-17/2 significa cada segunda hora entre 9 e 17. É uma abreviação para repetir em um intervalo fixo em vez de listar cada valor manualmente.`)
};

const pt_cr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A barra define um passo ou intervalo. No campo de minuto, */5 significa cada quinto minuto — 0, 5, 10, e assim por diante — enquanto 9-17/2 significa cada segunda hora entre 9 e 17. É uma abreviação para repetir em um intervalo fixo em vez de listar cada valor manualmente.`)
};

const ja_cr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スラッシュはステップまたは間隔を設定します。分フィールドでは、*/5は5分ごと（0、5、10など）を意味し、9-17/2は9～17間のすべての2番目の時間を意味します。これは、すべての値を手動でリストするのではなく、固定間隔で繰り返すための略語です。`)
};

const zh_cr_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`斜杠用于设置步长，也就是间隔。在分钟字段中，*/5 表示每隔五分钟——即 0、5、10 等——而 9-17/2 表示在 9 点到 17 点之间每隔两小时。它是一种按固定间隔重复的简写方式，无需手动列出每一个值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_faq4_a", locale)
	if (locale === "en") return en_cr_faq4_a(inputs)
	if (locale === "es") return es_cr_faq4_a(inputs)
	if (locale === "de") return de_cr_faq4_a(inputs)
	if (locale === "nl") return nl_cr_faq4_a(inputs)
	if (locale === "fr") return fr_cr_faq4_a(inputs)
	if (locale === "it") return it_cr_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_cr_faq4_a(inputs)
	if (locale === "pt") return pt_cr_faq4_a(inputs)
	if (locale === "ja") return ja_cr_faq4_a(inputs)
	return zh_cr_faq4_a(inputs)
};